<template>
  <div>
    <common-dialog
      ref="dialog"
      width="1050px"
      show-save-button
      unit="事务执行"
    
     
    >
      <template slot="form">

          <el-row>
          <el-col :span="24">
            <el-form-item label="事务标题">
             测试事项一
            </el-form-item>
          </el-col>
        </el-row>
                
        
        <el-row>

           <el-col :span="isMB?24:12">
            <el-form-item label="提交商家">
             达信
            </el-form-item>
          </el-col>
          <el-col :span="isMB?24:12">
            <el-form-item label="提交时间">
             2024-03-21 10:01:12
            </el-form-item>
          </el-col>
          
        </el-row>

        <el-row>
          
          <el-col :span="isMB?24:12">
            <el-form-item label="状态">
              <span  style="color:#f11;">处理中</span>
            
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item :label="isMB?'':'处理情况'" :label-width="isMB?'0':''" prop="">
              <el-divider v-if="isMB">处理情况</el-divider>
              <editor ref="editor"></editor>
              <el-input  v-show="false"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
       
      </template>
    </common-dialog>
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";
import editor from '@/components/common/editor';

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
    editor
  },
  data() {
    return {
      data: {
      
      },
   //   api: require("@/api/bstr/bstrcp").default,
      isMB: this.$store.state.isMB,
      rules: {
    //    ReplyNotes: [{ required: true, message: "答复情况不能为空" }],
      },
    };
  },
  methods: {
    onCreateOpened(row) {
      
    },
    onEditOpened(row) {
      
    },
    onBeforeSave() {
      
    },
    onClosed() {

    },
  },
};
</script>